import { FaqEntryFeedbackResp } from 'types/api/response/faq-entry-feedback-resp'
import { api } from '@marketplace-web/core-api/core-api-client-data'

export const getFaqEntryFeedbackData = (faqId: number) =>
  api.get<FaqEntryFeedbackResp>(`/faq_entries/${faqId}/feedback`)
